<!-- Tabs -->
<div class="tabs-container" [style.border-bottom-color]="buttonColorActive"
     *ngIf="availableTabs.length > 0">
  <button class="tab-button"
          *ngFor="let tab of availableTabs"
          [class.active]="tabAddons === tab.key"
          [style.background-color]="tabAddons === tab.key ? buttonColorActive : 'white'"
          (click)="tabAddons = tab.key">
    <img [src]="tab.icon" class="tab-icon" alt="">
    <p class="tab-text mb-0">{{ tab.label }}</p>
  </button>
</div>

<!-- Contenido unificado para todos los tipos de extras -->
<div class="extras-content">
  <div class="d-flex flex-column" style="border: 1px solid #ececec;">
    <p class="pl-4 mb-0 mt-3" style="font-family: 'Rubik'; font-size: 12px; font-weight: 600;line-height: 1; text-transform: capitalize;">
      Seleccionar opción
    </p>

    <!-- Carousel container -->
    <div class="carousel-container" *ngIf="getCurrentOptions().length > 0">
      <button class="carousel-nav prev"
              (click)="prevSlide()"
              [disabled]="currentSlide === 0"
              *ngIf="getCurrentOptions().length >= 3">
        &#10094;
      </button>

      <div class="carousel-track-wrapper">
        <div class="carousel-track"
              [class.single-item]="getCurrentOptions().length === 1"
              [style.transform]="'translateX(-' + (currentSlide * (100 / 2)) + '%)'"
              [style.transition]="'transform 0.3s ease-in-out'">

          <div class="carousel-card" *ngFor="let extra of getCurrentOptions(); let idx = index">
            <!-- Diseño unificado para los extras -->
            <div class="extra-card">
              <!-- Cabecera con título y precio -->
              <div class="extra-header">
                <div class="extra-info pr-2">
                  <p class="extra-title">{{ extra?.title }}</p>
                </div>
                <div class="extra-price">
                  <p class="price-amount">
                    {{ currencyAgency?.code }} {{ extra?.netcost?.amountProf
                      | currencyConverterPure: extra?.netcost?.currency: currencyAgency?.code: currencies
                      | number: '1.2-2' }}
                  </p>
                  <p *ngIf="currencyAgency?.code !== extra?.netcost?.currency" class="price-original">
                    {{ extra?.netcost?.currency }} {{ extra?.netcost?.amountProf | number: '1.2-2' }}
                  </p>
                </div>
              </div>

              <!-- Cuerpo con selector de habitación y descripción -->
              <div class="extra-body">
                <div class="detail-info-container">
                  <div class="room-extra-detail-config">
                    <p class="section-label">Habitación</p>
                    <mat-select
                      placeholder="{{selectedRooms.length > 0 ? 'Seleccione una habitación' : 'Seleccione una configuración de cuarto'}}"
                      multiple
                      class="center-placeholder-select form-control"
                      (selectionChange)="onSelectionChangeExtras($event, extra, tabAddons)"
                      [panelClass]="'wide-panel'"
                      [compareWith]="compareRooms"
                      [value]="getSelectedRoomsForExtra(extra, tabAddons)"
                      [disabled]="selectedRooms.length === 0">
                      <mat-option *ngFor="let selectedRoom of selectedRooms; let i = index"
                                  [value]="selectedRoom"
                                  [disabled]="!isRoomAvailableForExtra(selectedRoom, extra, tabAddons)"
                      >
                      <span [class.text-muted]="!isRoomAvailableForExtra(selectedRoom, extra, tabAddons)">
                         Habitación {{i+1}}: {{ selectedRoom?.room?.qtyAdults }} Adultos - {{ selectedRoom?.room?.qtyChilds }} Niños
                         <span *ngIf="!isRoomAvailableForExtra(selectedRoom, extra, tabAddons)">
                           {{ getRoomAvailabilityMessage(selectedRoom, extra, tabAddons) }}
                          </span>
                      </span>



                      </mat-option>
                    </mat-select>

                    <div *ngIf="getTypeByTab(tabAddons) === 'Transfer' || getTypeByTab(tabAddons) === 'Attractions'" class="mt-3">
                      <p class="section-label">Capacidad</p>
                      <div class="d-flex">
                        <div class="capacity-item">
                          <img src="../../../../../assets/icons/search-result/persona.svg" class="capacity-icon" alt="">
                          <p class="capacity-text">1 Adultos</p>
                        </div>
                        <div class="capacity-item">
                          <img src="../../../../../assets/icons/search-result/persona.svg" class="capacity-icon" alt="">
                          <p class="capacity-text">0 Niños</p>
                        </div>
                      </div>
                    </div>

                    <div *ngIf="getTypeByTab(tabAddons) === 'Transfer' || getTypeByTab(tabAddons) === 'Attractions'" class="datetime-row">
                      <div class="datetime-item">
                        <p class="section-label">Fecha</p>
                        <div class="datetime-content">
                          <img src="../../../../../assets/icons/itinerary/calendar_13937514.svg" class="datetime-icon" alt="">
                          <p class="datetime-text">{{arrivalDate | date: 'dd/MM/YYYY'}}</p>
                        </div>
                      </div>
                      <!-- <div class="datetime-item">
                        <p class="section-label">Hora</p>
                        <div class="datetime-content">
                          <img src="../../../../../assets/icons/itinerary/reloj-circular.svg" class="datetime-icon-clock" alt="">
                          <p class="datetime-text">12:00 hs</p>
                        </div>
                      </div> -->
                    </div>
                  </div>
                </div>

                <div class="description-section mt-3">
                  <p class="description-text">{{ extra?.description }}</p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <button class="carousel-nav next"
              (click)="nextSlide()"
              [disabled]="currentSlide >= getCurrentOptions().length - 2"
              *ngIf="getCurrentOptions().length >= 3">
        &#10095;
      </button>
    </div>

  </div>
</div>
